import type { ReactNode } from "react";

export function PageHeader({
  title,
  subtitle,
  extra,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 16,
        padding: "20px 24px",
        borderBottom: "1px solid var(--ant-color-border)",
        background: "var(--ant-color-bg-container)",
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, letterSpacing: -0.3 }}>{title}</h1>
        {subtitle ? (
          <div
            style={{
              marginTop: 4,
              fontSize: 15,
              color: "var(--ant-color-text-secondary)",
            }}
          >
            {subtitle}
          </div>
        ) : null}
      </div>
      {extra ? <div style={{ flexShrink: 0 }}>{extra}</div> : null}
    </div>
  );
}
